export const VERIFICATION = {
  SMS: 'sms',
  EMAIL: 'email',
};

// What the user is verifying for, so the inline mobile verification flow knows where to go once verified
export const VERIFICATION_INTENT = {
  POD: 'pod',
  LIVE_DETAILS: 'live_details',
  MANAGE_DELIVERY: 'manage_delivery',
  FEEDBACK: 'feedback',
};
